import { Optional } from 'utility-types';

import { FacetKey } from '@app/components';
import { isTestEnv, ShapeWithTotalRecords } from '@app/constants';

export interface MappedFacetValue {
  value: string;
  count: number;
  id: string;
  label: string;
}

export type MappedFacetValues = MappedFacetValue[] | null;

export type UnmappedFacetValue = ShapeWithTotalRecords<{
  id: string;
}>;

type FacetsItemDto = ShapeWithTotalRecords<{
  values: UnmappedFacetValue[];
}>;

export interface FacetsDto {
  facets: Optional<
    Record<
      | 'sourceTypes'
      | 'languages'
      | 'items.effectiveLocationId'
      | 'instanceSubjects'
      | 'instancePublishers'
      | 'patronItemStatus',
      FacetsItemDto
    >
  >;
}

export type FacetInstanceDto = Record<
  FacetKey,
  {
    label: string;
    values: null | MappedFacetValue[];
    isError?: boolean;
    isSearchable?: boolean;
  }
>;

export const facetAttributesLimit = 6;

export const facetLimit = isTestEnv ? 10 : 500;
